import React from 'react';
import { Grid } from '@mui/material';
import ComponentProps from 'store/types/ComponentProps';
import { defaultGridItemProps } from 'util/Layout';
import PaymentMethodCardType from 'store/enums/PaymentMethodCardType';
import { getPaymentCardTypeConfig } from 'util/Payment';

const defaultCardsConfig: PaymentMethodCardType[] = [
  PaymentMethodCardType.Visa,
  PaymentMethodCardType.Mastercard,
  PaymentMethodCardType.Amex,
  PaymentMethodCardType.Diners,
  PaymentMethodCardType.Discover,
];

interface PaymentCardImagesProps extends ComponentProps {
  acceptedCardTypes?: PaymentMethodCardType[];
}

const PaymentCardImages: React.FunctionComponent<PaymentCardImagesProps> = ({ acceptedCardTypes, className = '' }) => {
  const cardTypesToRender = acceptedCardTypes && acceptedCardTypes.length ? acceptedCardTypes : defaultCardsConfig;

  return (
    <Grid {...defaultGridItemProps} className={className}>
      {cardTypesToRender.map((name: PaymentMethodCardType) => {
        const { text = '', icon = '' } = getPaymentCardTypeConfig(name);

        return <img key={text} src={icon} alt={text} />;
      })}
    </Grid>
  );
};
export default PaymentCardImages;
